import { Link } from 'react-router-dom';
import { BookOpen, Gift, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function AdminDashboard() {
  return (
    <div>
      <h1 className="font-heading text-4xl font-light text-primary mb-8" data-testid="admin-dashboard-title">
        Dashboard
      </h1>

      <div className="grid md:grid-cols-2 gap-6">
        <Link to="/admin/books" data-testid="admin-dashboard-books-card">
          <div className="bg-card border border-border rounded-xl p-8 hover:shadow-md transition-shadow">
            <BookOpen className="h-12 w-12 text-primary mb-4" />
            <h2 className="font-heading text-2xl font-normal mb-2">Manage Books</h2>
            <p className="text-muted-foreground mb-4">
              Add, edit, and organize children's literature recommendations
            </p>
            <Button variant="ghost" className="group">
              Go to Books
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </Link>

        <Link to="/admin/gifts" data-testid="admin-dashboard-gifts-card">
          <div className="bg-card border border-border rounded-xl p-8 hover:shadow-md transition-shadow">
            <Gift className="h-12 w-12 text-primary mb-4" />
            <h2 className="font-heading text-2xl font-normal mb-2">Manage Gifts</h2>
            <p className="text-muted-foreground mb-4">
              Add, edit, and organize gift recommendations for moms and kids
            </p>
            <Button variant="ghost" className="group">
              Go to Gifts
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </Link>
      </div>
    </div>
  );
}